module.exports = __webpack_public_path__ + "static/img/map_guangdong.0afe442.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_guangdong.png
// module id = vm9q
// module chunks = 0